module.exports = __webpack_public_path__ + "img/play.6a6d61d7.png";